var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationStatusBallDecor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 124,
    viewBox: "0 0 305 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.043 24.5151C326.93 -14.9023 303.676 -60.32 254.103 -76.9282C204.531 -93.5364 147.413 -75.0458 126.526 -35.6284C105.639 3.78903 128.893 49.2068 178.465 65.8149C228.038 82.4231 285.156 63.9326 306.043 24.5151Z",
    fill: "url(#paint0_linear_793_6880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.372 12.736C199.45 -28.5799 146.041 -53.0987 94.0814 -42.0281C42.1216 -30.9575 11.2863 11.5102 25.2089 52.8261C39.1315 94.1421 92.5398 118.661 144.5 107.59C196.459 96.5196 227.295 54.052 213.372 12.736Z",
    fill: "url(#paint1_linear_793_6880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_6880",
    x1: 97.0069,
    y1: -44.8703,
    x2: 388.172,
    y2: 106.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_793_6880",
    x1: -5.23208,
    y1: 59.93,
    x2: 311.759,
    y2: -49.3855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0E3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusBallDecor);
export default __webpack_public_path__ + "static/media/ApplicationStatusBallDecor.d03c402aaa001f15a07921c39db14802.svg";
export { ForwardRef as ReactComponent };